import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

export const baseURL = 'https://boxmetr.ru'
// export const baseURL = 'https://boxmetr.local'


export type ApiErrorResponse<T = string> = {
  message: T | T[];
  statusCode: number;
  error?: string;
}

function api() {
  const publicApi = axios.create({ baseURL, withCredentials: true });
  return {publicApi}
}




export function ErrorQueryHandler(error:unknown): undefined {
  const axiosError = error as AxiosError<ApiErrorResponse>;
  const err = axiosError?.response?.data?.message
  if(!err) throw 'Unknown error.'
  const errorMessage = Array.isArray(err) ? err.join(', ') : err
  throw errorMessage
}

export function ErrorHandler(error:unknown): {error?: string} {
  const axiosError = error as AxiosError<ApiErrorResponse>;
  const err = axiosError?.response?.data?.message
  if(!err) return {error:'Unknown error.'}
  const errorMessage = Array.isArray(err) ? err.join(', ') : err
  return {
    error: errorMessage
  }
}

export function SuccessHandler<TData>(res: AxiosResponse<TData>): TData {
  if(!res?.data) throw res
  return res.data
}

export const {publicApi} = api();



export const sendForm = async <T>(data: T) => {
  try {
    const response = await publicApi.post('main/mail/', data, {baseURL: '/'});
    if(response?.data?.result) return {success: true, result: response.data.result}
    return new Error(response?.data?.message || 'Произошла ошибка')
  } catch (error:any) {
    throw new Error(error.response?.data?.message || 'Произошла ошибка')
  }

};
